import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  // Full navy page background. The navy sidebar blends into the page, leaving the
  // content area to float as a white card. paddingTop reserves space for the fixed
  // full-width header.
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
    paddingTop: '71px',
    '@media (max-width: 1024px)': {
      paddingTop: '61px',
    },
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      position: 'relative',
    },
  },
  sidebar: {
    width: '100%',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '0 32px 32px 0',
    position: 'relative',
    justifyContent: 'center',
    overflow: 'hidden',
    // Desktop: fill the space left of the right-aligned card.
    '@media (min-width: 769px)': {
      maxWidth: '50%',
    },
    '@media (max-width: 768px)': {
      maxWidth: '100%',
      height: 'auto',
      padding: '0',
      justifyContent: 'flex-start',
      marginBottom: '0px',
      flex: '0 0 auto',
    },
  },
  sidebarHidden: {
    '@media (max-width: 992px)': {
      display: 'none !important',
    },
  },
  sideBarTopParent: {
    zIndex: 2,
    // Desktop: cap the left content at 662px, centered in the left region.
    '@media (min-width: 769px)': {
      width: '100%',
      maxWidth: '662px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    '@media (max-width: 768px)': {
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
      borderRadius: '0 0 40px 40px',
      padding: '0 24px 0 24px',
      marginBottom: '0',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    '@media (max-width: 768px) and (max-height: 600px)': {
      borderRadius: '0 0 36px 36px',
    },
    '@media (max-width: 768px) and (max-height: 480px)': {
      borderRadius: '0 0 32px 32px',
    },
  },
  sideBarTopParentHidden: {
    '@media (min-width: 992px)': {
      display: 'none !important',
    },
  },
  sidebarLogoParent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: '6px',
    marginLeft: '6px',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
      marginLeft: '0',
      marginTop: '49px',
    },
  },
  sidebarLogo: {
    '@media (max-width: 768px)': {
      width: '90px',
      height: 'auto',
    },
  },
  sidebarTextParent: {
    '@media (max-width: 992px)': {
      marginTop: '36px',
      marginBottom: '40px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  sidebarTitle: {
    fontSize: '38px',
    lineHeight: '42px',
    fontWeight: 600,
    color: STYLE.COLOR.WHITE,
    textAlign: 'center',
    '@media (max-width: 900px)': {
      fontSize: '32px',
      lineHeight: '40px',
    },
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '32px',
      marginBottom: '8px',
    },
  },
  sidebarSubtitle: {
    fontSize: '38px',
    lineHeight: '42px',
    fontWeight: 600,
    color: STYLE.COLOR.WHITE,
    textAlign: 'center',
    '@media (max-width: 900px)': {
      fontSize: '32px',
      lineHeight: '40px',
    },
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '32px',
    },
  },
  sideBarBottomParent: {
    // Desktop: cap the left content at 662px, centered in the left region.
    '@media (min-width: 769px)': {
      width: '100%',
      maxWidth: '662px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  sidebarImageParent: {
    marginBottom: 72,
    marginTop: 72,
  },
  sidebarImage: {
    width: '100%',
    height: '100%',
  },
  sidebarActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '56px',
    '@media (max-width: 992px)': {
      gap: '36px',
    },
    '@media (max-width: 768px)': {
      gap: '24px',
      flexWrap: 'wrap',
    },
  },
  actionItem: {
    color: STYLE.COLOR.WHITE,
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
    '&:hover': {
      opacity: 0.8,
    },
    '@media (max-width: 768px)': {
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '30px',
    overflowY: 'auto',
    flex: 1,
    '@media (min-width: 992px)': {
      maxWidth: '50%',
      padding: 0,
    },
    '@media (max-width: 992px)': {
      padding: '0px 16px 16px 16px',
      alignItems: 'flex-start',
      width: 'auto',
      flex: '1 1 auto',
      minHeight: 0,
    },
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '30px',
    '@media (min-width: 1025px)': {
      // height: 'calc(100vh - 131px)',
    },
    '@media (max-width: 1024px)': {
      // height: 'initial',
      alignItems: 'center',
    },
    '@media (max-width: 992px)': {
      maxWidth: '100%',
      margin: '0',
    },
  },
  card: {
    width: '100%',
    background: STYLE.COLOR.WHITE,
    borderRadius: '50px',
    padding: '48px 55px',
    height: '100%',
    maxWidth: '800px',
    '@media (min-width: 769px) and (max-width: 992px)': {
      maxWidth: '80%',
    },
    '@media (min-width: 769px)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    '@media (max-width: 992px)': {
      padding: '40px',
    },
    '@media (max-width: 768px)': {
      borderRadius: '16px',
      padding: '16px',
    },
  },
  headerFloating: {
    width: '100%',
    maxWidth: '100%',
  },
  buttonParent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
      marginTop: '20px',
    },
  },
  button: {
    width: 182,
    '@media (max-width: 768px)': {
      width: '100%',
      maxWidth: '280px',
    },
  },
  mobileSidebarActions: {
    display: 'none',
    marginTop: '40px',
    '@media (max-width: 992px)': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '20px 16px',
      flexWrap: 'wrap',
    },
    '@media (min-width: 769px) and (max-width: 992px)': {
      justifyContent: 'center',
      gap: '56px',
    },
    '@media (max-width: 480px)': {
      gap: '16px',
      padding: '16px 12px',
      flexDirection: 'row',
    },
  },
  // The mobile footer sits on the navy page, so its links are white.
  mobileActionItem: {
    color: STYLE.COLOR.WHITE,
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    background: 'none',
    border: 'none',
    padding: 0,
    fontFamily: 'inherit',
    '&:hover': {
      opacity: 0.8,
    },
    '@media (max-width: 600px)': {
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  header: {
    width: '100%',
    maxWidth: 'calc(100% - 705px)',
    '@media (max-width: 1200px)': {
      maxWidth: '50%',
    },
    '@media (max-width: 768px)': {
      maxWidth: '100%',
    },
  },
  contentContainerWithWarning: {
    '@media (max-width: 768px)': {
      paddingTop: '40px',
    },
  },
}));
